import { render, staticRenderFns } from "./overzicht.vue?vue&type=template&id=fec46fa4&"
import script from "./overzicht.vue?vue&type=script&lang=js&"
export * from "./overzicht.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports